import ambassadorHOC from "../../ambassador-hoc";
import { AmbassadorInitiatives } from "./initiatives";

export default ambassadorHOC(AmbassadorInitiatives);
